var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 499 364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_3);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442);\n      }\n\n      .cls-3, .cls-8 {\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4-2);\n      }\n\n      .cls-6 {\n        fill: #c00000;\n      }\n\n      .cls-7 {\n        fill: #ffc020;\n      }\n\n      .cls-8 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    cx: 331.06,
    cy: 201.8,
    fx: 331.06,
    fy: 201.8,
    r: 158,
    gradientTransform: "translate(-148.68 -18.5) rotate(70.05) scale(.88 -.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 158.02,
    y1: 177.85,
    x2: 158.02,
    y2: -34.3,
    gradientTransform: "translate(1.37 205.33) scale(.41 -.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 3",
    x1: 72.98,
    y1: 244.95,
    x2: 168.51,
    y2: 139.33,
    gradientTransform: "translate(1.37 205.33) scale(.41 -.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 160.95,
    y1: 111.79,
    x2: 296.85,
    y2: 111.79,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg1248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path855",
    className: "cls-4",
    d: "m92.06,340h19.2v-38.4l29.9,38.4h17v-70h-19.2v37l-28.8-37h-18.1v70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path857",
    className: "cls-4",
    d: "m192.58,340h56.8v-16.5h-37.6v-11.1h33.6v-15.3h-33.6v-10.6h37.1v-16.5h-56.3v70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path859",
    className: "cls-4",
    d: "m301.4,340.5h16.9l14-40.3,14.1,40.3h16.9l23.4-70.5h-20.1l-12.2,40.5-13.5-40.7h-16.7l-13.5,40.7-12.2-40.5h-20.5l23.4,70.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path861",
    className: "cls-4",
    d: "m440.64,341.2c17,0,28.3-8.5,28.3-22.8v-.2c0-13.1-10-18.3-26.1-21.8-9.7-2.2-12.1-3.6-12.1-6.8v-.2c0-2.5,2.3-4.5,7-4.5,6.2,0,13.2,2.4,19.6,6.9l9.7-13.7c-7.6-6.1-16.9-9.3-28.8-9.3-16.8,0-27.1,9.4-27.1,22.4v.2c0,14.4,11.5,18.6,26.4,22,9.5,2.2,11.8,3.8,11.8,6.7v.2c0,3-2.8,4.8-8,4.8-8.1,0-15.8-2.9-22.7-8.4l-10.8,12.9c8.6,7.7,20.4,11.6,32.8,11.6h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "rect913",
    className: "cls-2",
    x: 62,
    width: 437,
    height: 364
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect915",
    className: "cls-4",
    x: 64,
    y: 2,
    width: 433,
    height: 360
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect866",
    className: "cls-7",
    d: "m75,244v14c83.16,82,393.94,60.4,411,0v-14c-19.5-161.89-315.07-54.86-411,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect847",
    className: "cls-2",
    x: 75,
    y: 258,
    width: 411,
    height: 94
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect868",
    className: "cls-6",
    x: 75,
    y: 13,
    width: 411,
    height: 231
  }), /*#__PURE__*/React.createElement("path", {
    id: "path910",
    className: "cls-4",
    d: "m216.26,19.5c-58.36,0-101.61,19.13-105.26,81.08h64.1c1.82-24.29,18.76-34.31,40.9-34.31,23.45.3,34.65,9.72,34.65,23.08,0,10.32-8.34,17.92-18.76,21.26l-43.51,14.27c-45.86,14.88-81.29,39.78-83.63,109.62h173.18l.14-.84c2.72-15.9,8.03-31.16,15.38-45.92h-122.52c25.53-38.57,143.82-17.92,143.82-97.48,0-47.37-38.3-70.76-98.49-70.76h0Zm53.64,3c7.78,2.76,14.82,6.23,21.01,10.49,12.42,8.55,21.25,20.34,25.65,34.85h84.61l-37.98,37.68c-40.83,40.51-72.2,82.21-80.2,128.98h83.12c11.15-60.97,49.93-103.86,100.38-153.79V22.5h-196.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "text857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path860",
    className: "cls-4",
    d: "m122.4,340.5h16.9l14-40.3,14.1,40.3h16.9l23.4-70.5h-20.1l-12.2,40.5-13.5-40.7h-16.7l-13.5,40.7-12.2-40.5h-20.5l23.4,70.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path862",
    className: "cls-4",
    d: "m225.42,340h19.4v-26.6h24.9v26.6h19.4v-70h-19.4v26.2h-24.9v-26.2h-19.4v70Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path864",
    className: "cls-4",
    d: "m328.69,340h19.4v-53h21v-17h-61.4v17h21v53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path866",
    className: "cls-4",
    d: "m387.6,340h19v-40l17.8,27.2h.4l17.9-27.4v40.2h19.3v-70h-20.5l-16.7,27.1-16.7-27.1h-20.5v70Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle915",
    className: "cls-2",
    cx: 66,
    cy: 159.5,
    r: 66
  }), /*#__PURE__*/React.createElement("g", {
    id: "g895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3011",
    className: "cls-3",
    d: "m64.35,96.08c-21.76.33-42.72,12.83-53.54,31.65-11.94,20.06-11.41,46.81,1.44,66.33,12,19.05,34.58,30.66,57.03,29.25,23.14-.91,44.95-15.66,54.55-36.68,10.04-20.94,7.2-47.33-7.18-65.62-12.17-16.05-32.08-25.6-52.3-24.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3151",
    className: "cls-8",
    d: "m64.35,96.08c-21.76.33-42.72,12.83-53.54,31.65-11.94,20.06-11.41,46.81,1.44,66.33,12,19.05,34.58,30.66,57.03,29.25,23.14-.91,44.95-15.66,54.55-36.68,10.04-20.94,7.2-47.33-7.18-65.62-12.17-16.05-32.08-25.6-52.3-24.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3016",
    className: "cls-1",
    d: "m3.52,144.79c2.25-8.24,3.73-14.61,15.07-28.33,6.47-6,11.96-11.96,25.76-17.15,7.25-2.36,14.38-3.74,21.82-3.74,9.39,0,18.87,1.87,28.43,6.63-.62,22.7-7.09,34.02-15.72,41.13-17.29,13.19-32.35,17.12-46.69,18.1-13.13.69-22.09-8.23-29.19-14.47-.12-.1.65-2.08.53-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3015-9",
    className: "cls-5",
    d: "m24.48,139.85c-10.77,0-19.41,8.83-19.41,19.77s8.64,19.77,19.41,19.77c6.61,0,9.2-4.75,9.2-4.75v4.32h10.21v-19.34c0-10.94-8.64-19.77-19.41-19.77Zm0,10.33c5.13,0,9.25,4.21,9.25,9.43s-4.12,9.43-9.25,9.43-9.25-4.21-9.25-9.43,4.12-9.43,9.25-9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3436",
    className: "cls-4",
    d: "m23.56,139.49c-11.22,0-20.23,9.04-20.23,20.25s9,20.25,20.23,20.25c6.89,0,9.58-4.86,9.58-4.86v4.43h10.64v-19.81c0-11.21-9-20.25-20.23-20.25Zm0,10.59c5.35,0,9.64,4.31,9.64,9.66s-4.29,9.66-9.64,9.66-9.64-4.31-9.64-9.66,4.29-9.66,9.64-9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3438",
    className: "cls-4",
    d: "m46.36,125.54v34.19c0,11.21,9.01,20.26,20.23,20.26s20.21-9.05,20.21-20.26-8.99-20.26-20.21-20.26c-6.89,0-9.59,4.88-9.59,4.88v-18.82h-10.64Zm20.23,24.53c5.35,0,9.64,4.32,9.64,9.66s-4.29,9.66-9.64,9.66-9.64-4.32-9.64-9.66,4.29-9.66,9.64-9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3440",
    className: "cls-4",
    d: "m108.76,139.49c-11.22,0-20.23,9.04-20.23,20.25s9,20.25,20.23,20.25c9.69,0,17.72-6.74,19.74-15.79h-11.19c-1.6,3.09-4.82,5.2-8.55,5.2-5.35,0-9.64-4.31-9.64-9.66s4.29-9.66,9.64-9.66c3.75,0,6.98,2.12,8.58,5.22h11.16c-2.01-9.06-10.05-15.81-19.74-15.81Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32);
export default __webpack_public_path__ + "static/media/32.5d53e387db389402f4996324e4ed1e44.svg";
export { ForwardRef as ReactComponent };